// src/shared/api/qs.js

// Converts an object to a URL query string
export function qs(params = {}) {
  const p = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    p.append(k, String(v));
  });
  const s = p.toString();
  return s ? `?${s}` : "";
}
